import { render, staticRenderFns } from "./AddressRequirementsPlanningGroupDialog.vue?vue&type=template&id=5bdb8ab4&scoped=true&lang=pug&"
import script from "./AddressRequirementsPlanningGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressRequirementsPlanningGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb8ab4",
  null
  
)

export default component.exports